// Utility functions for customer handling

/**
 * Get company name from customer ID
 * 
 * @param customerId The customer ID
 * @param customers Array of customers from Redux state
 * @param fallback Optional fallback text
 * @returns The company name or fallback string
 */
export const getCustomerName = (
  customerId: string,
  customers: any[],
  fallback = 'Unknown Customer'
): string => {
  if (!customerId || !customers || !customers.length) return fallback;

  const customer = customers.find(c => c.id === customerId);
  return customer ? customer.companyName : fallback;
};

/**
 * Function to apply consistent customer name formatting in project tables
 * This function replaces the "let customerName" code blocks that appear in multiple files
 */
export const extractCustomerName = (project: any, customers: any[]): string => {
  // If project already has a customerName that's not a "Client #" placeholder, use it
  if (project?.customerName && !project.customerName.startsWith('Client #')) {
    return project.customerName;
  }
  
  // Otherwise lookup from customers array
  if (project?.ClientId && customers && customers.length > 0) {
    const customer = customers.find(c => c.id === project.ClientId);
    if (customer && customer.companyName) {
      return customer.companyName;
    }
  }
  
  // Last fallback - use a reasonable default that's not "Client #id"
  return project?.projectOwner || 'Unknown Client';
};
